import React from "react";

import { Show, SimpleShowLayout, TextField } from "react-admin";

const ShowPublicProcurementActProcedures = () => {
  return (
    <Show title="Процедура (номенклатура)">
      <SimpleShowLayout>
        <TextField
          label="Име"
          source="name"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowPublicProcurementActProcedures;
